import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import MembershipLegalPage from './components/MembershipLegalPage';
import LegalFooter from './components/LegalFooter';
import './legal.css';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      {window.location.pathname.replace(/\/$/, "") === "/terms" ? (
        <MembershipLegalPage policy="terms" />
      ) : window.location.pathname.replace(/\/$/, "") === "/fair-use" ? (
        <MembershipLegalPage policy="fair-use" />
      ) : (
        <App />
      )}
      <LegalFooter />
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();